export const translations = {
  en: {
    nav: { home: "Home", phones: "Phones", accessories: "Accessories", about: "About Us", contact: "Contact", quote: "Request a Quote" },
    common: {
      search: "Search products, brands, models…",
      searchBtn: "Search",
      viewDetails: "View Details",
      requestQuote: "Request Quote",
      whatsappSales: "WhatsApp Sales",
      whatsapp: "WhatsApp",
      brand: "Brand",
      model: "Model",
      storage: "Storage",
      color: "Color",
      condition: "Condition",
      price: "Price",
      availability: "Availability",
      description: "Description",
      specifications: "Specifications",
      admin: "Admin",
      loading: "Loading…",
      noResults: "No products found.",
      exploreAll: "Explore All",
      exploreProducts: "Explore Products",
      email: "Email",
    },
    hero: {
      headline: "Technology Distribution, Connected from Dubai.",
      sub: "AFC TELECOM is a Dubai-based B2B technology distributor connecting mobile devices, electronics and accessories with business buyers across regional and international markets.",
      cta1: "Explore Products",
      cta2: "Request a Quote",
      badge: "Dubai · DAFZA W5",
    },
    home: {
      dubaiTitle: "Dubai. Connected to Global Markets.",
      dubaiSub: "Operating from Dubai, one of the world's most connected trade hubs, AFC TELECOM serves business buyers with a strategic UAE presence and fast access to regional and international logistics.",
      networkTitle: "A Global Supply Network.",
      networkSub: "Dubai as a central hub, servicing business buyers across regional and international markets.",
      categories: "Product Categories",
      categoriesSub: "Explore our full range of smartphones and technology accessories.",
      b2bTitle: "Built for Business.",
      b2bSub: "AFC TELECOM focuses on B2B technology supply. From single-line inquiries to full-container programs, our sales desk is set up for business buyers.",
      featured: "Featured Products",
      featuredSub: "Selected items from our current catalog.",
      whyTitle: "Why AFC TELECOM",
      whyPoints: [
        { t: "Dubai-Based", d: "Operating from DAFZA W5, in the heart of Dubai's technology trade corridor." },
        { t: "B2B Focused", d: "A sales desk built around business inquiries, quotes and volume orders." },
        { t: "Mobile & Accessories", d: "Smartphones and a full range of accessories from leading brands." },
        { t: "Regional & International", d: "Serving buyers across the Middle East and beyond." },
      ],
      finalCta: "Looking for your next technology supply partner?",
      finalCtaSub: "Send us your requirements and our sales team will get back to you.",
    },
    availability: { Available: "Available", "Out of Stock": "Out of Stock", "On Request": "On Request" },
    contact: {
      title: "Contact AFC TELECOM",
      sub: "Talk to our sales team for pricing, availability, and B2B orders.",
      sales: "Sales", management: "Management", location: "Location",
      call: "Call", email: "Email", openMaps: "Open in Maps",
      formTitle: "Send us a message",
      name: "Name", phone: "Phone / WhatsApp", emailField: "Email", message: "Message",
      send: "Send Message", sent: "Message sent. Our team will contact you soon.",
    },
    quote: {
      title: "Request a Quote",
      sub: "Tell us what you're sourcing and we'll get back with pricing and availability.",
      name: "Full Name",
      company: "Company Name",
      email: "Email",
      phone: "Phone / WhatsApp",
      product: "Product",
      quantity: "Quantity",
      message: "Additional details",
      submit: "Submit Request",
      submitted: "Thank you. Your request has been received.",
    },
    about: {
      title: "About AFC TELECOM",
      p1: "AFC TELECOM is a Dubai-based B2B technology distributor operating from DAFZA W5. We focus on the distribution of mobile phones, smartphones, electronics and accessories to business buyers.",
      p2: "Our sales desk is structured around business inquiries — pricing, availability, mixed configurations and volume orders. We work with a curated selection of leading brands and models across the categories we serve.",
      p3: "Positioned in Dubai, one of the world's most active trade corridors, AFC TELECOM connects supply with regional and international business buyers.",
    },
    admin: {
      title: "Admin Dashboard", products: "Products", inquiries: "Inquiries", settings: "Settings",
      addProduct: "Add Product", edit: "Edit", delete: "Delete", save: "Save", cancel: "Cancel",
    },
    footer: {
      rights: "All rights reserved.",
      tagline: "Technology Distribution, Connected from Dubai.",
      quickLinks: "Explore", contact: "Contact",
    },
    whatsappMsgs: {
      general: "Hello AFC TELECOM, I would like to inquire about your products.",
      product: (name) => `Hello AFC TELECOM, I am interested in ${name}. Please provide availability and pricing.`,
      quote: "Hello AFC TELECOM, I would like to request a quote.",
    },
    markets: ["UAE", "Middle East", "Europe", "Asia", "Africa"],
  },
  ar: {
    nav: { home: "الرئيسية", phones: "الهواتف", accessories: "الإكسسوارات", about: "من نحن", contact: "تواصل معنا", quote: "طلب عرض سعر" },
    common: {
      search: "ابحث عن المنتجات، الماركات، الموديلات…", searchBtn: "بحث", viewDetails: "عرض التفاصيل",
      requestQuote: "طلب عرض سعر", whatsappSales: "واتساب المبيعات", whatsapp: "واتساب",
      brand: "الماركة", model: "الموديل", storage: "السعة", color: "اللون", condition: "الحالة",
      price: "السعر", availability: "التوفر", description: "الوصف", specifications: "المواصفات",
      admin: "المسؤول", loading: "جارٍ التحميل…", noResults: "لا توجد منتجات.",
      exploreAll: "استعرض الكل", exploreProducts: "استعرض المنتجات", email: "البريد الإلكتروني",
    },
    hero: {
      headline: "توزيع التكنولوجيا، من قلب دبي إلى العالم.",
      sub: "AFC TELECOM موزع B2B لتقنية الاتصالات ومقرها دبي، يربط الأجهزة المحمولة والإلكترونيات والإكسسوارات بالعملاء التجاريين في الأسواق الإقليمية والدولية.",
      cta1: "استعرض المنتجات", cta2: "طلب عرض سعر", badge: "دبي · دافزا W5",
    },
    home: {
      dubaiTitle: "دبي. متصلة بالأسواق العالمية.",
      dubaiSub: "من قلب دبي، إحدى أكثر مناطق التجارة اتصالاً في العالم، نخدم العملاء التجاريين بحضور استراتيجي في الإمارات وسرعة وصول إلى الأسواق الإقليمية والدولية.",
      networkTitle: "شبكة توريد عالمية.",
      networkSub: "دبي كمركز رئيسي يخدم العملاء التجاريين في الأسواق الإقليمية والدولية.",
      categories: "فئات المنتجات",
      categoriesSub: "استعرض تشكيلتنا من الهواتف الذكية وإكسسوارات التكنولوجيا.",
      b2bTitle: "مصممة للأعمال.",
      b2bSub: "يركز AFC TELECOM على توريد التكنولوجيا للأعمال. من الاستفسارات الفردية إلى برامج الكميات الكبيرة.",
      featured: "منتجات مميزة", featuredSub: "مختارات من كتالوجنا الحالي.",
      whyTitle: "لماذا AFC TELECOM",
      whyPoints: [
        { t: "من دبي", d: "نعمل من دافزا W5، في قلب ممر تجارة التكنولوجيا في دبي." },
        { t: "تركيز B2B", d: "منصة مبيعات مبنية على استفسارات الأعمال والعروض والطلبات الكبيرة." },
        { t: "هواتف وإكسسوارات", d: "هواتف ذكية وتشكيلة كاملة من الإكسسوارات من علامات رائدة." },
        { t: "إقليمي ودولي", d: "نخدم العملاء في الشرق الأوسط وما بعده." },
      ],
      finalCta: "تبحث عن شريك توريد تقني موثوق؟",
      finalCtaSub: "أرسل لنا متطلباتك وسيتواصل معك فريق المبيعات.",
    },
    availability: { Available: "متوفر", "Out of Stock": "غير متوفر", "On Request": "حسب الطلب" },
    contact: {
      title: "تواصل مع AFC TELECOM", sub: "تحدث مع فريق المبيعات للاستفسار عن الأسعار والتوفر وطلبات الشركات.",
      sales: "المبيعات", management: "الإدارة", location: "الموقع",
      call: "اتصل", email: "البريد", openMaps: "فتح الخريطة",
      formTitle: "أرسل لنا رسالة",
      name: "الاسم", phone: "الهاتف / واتساب", emailField: "البريد الإلكتروني", message: "الرسالة",
      send: "إرسال الرسالة", sent: "تم إرسال الرسالة. سيتواصل معك فريقنا قريباً.",
    },
    quote: {
      title: "طلب عرض سعر", sub: "أخبرنا بما تبحث عنه وسنعود إليك بالأسعار والتوفر.",
      name: "الاسم الكامل", company: "اسم الشركة", email: "البريد الإلكتروني",
      phone: "الهاتف / واتساب", product: "المنتج", quantity: "الكمية", message: "تفاصيل إضافية",
      submit: "إرسال الطلب", submitted: "شكراً لك. تم استلام طلبك.",
    },
    about: {
      title: "عن AFC TELECOM",
      p1: "AFC TELECOM موزع B2B لتقنية الاتصالات مقره دبي، يعمل من دافزا W5. نركّز على توزيع الهواتف المحمولة والإلكترونيات والإكسسوارات للعملاء التجاريين.",
      p2: "منصة المبيعات لدينا مصممة حول استفسارات الأعمال — الأسعار، التوفر، التكوينات المختلطة والطلبات بالكميات.",
      p3: "من موقعنا في دبي، إحدى أكثر ممرات التجارة نشاطاً في العالم، نربط التوريد بالعملاء التجاريين إقليمياً ودولياً.",
    },
    admin: {
      title: "لوحة تحكم المسؤول", products: "المنتجات", inquiries: "الاستفسارات", settings: "الإعدادات",
      addProduct: "إضافة منتج", edit: "تعديل", delete: "حذف", save: "حفظ", cancel: "إلغاء",
    },
    footer: {
      rights: "جميع الحقوق محفوظة.",
      tagline: "توزيع التكنولوجيا، من قلب دبي إلى العالم.",
      quickLinks: "استكشاف", contact: "تواصل",
    },
    whatsappMsgs: {
      general: "مرحبا AFC TELECOM، أود الاستفسار عن منتجاتكم.",
      product: (name) => `مرحبا AFC TELECOM، أنا مهتم بـ ${name}. يرجى إرسال التوفر والسعر.`,
      quote: "مرحبا AFC TELECOM، أود طلب عرض سعر.",
    },
    markets: ["الإمارات", "الشرق الأوسط", "أوروبا", "آسيا", "أفريقيا"],
  },
};

export const t = (lang, path) => {
  const parts = path.split(".");
  let cur = translations[lang];
  for (const p of parts) { if (cur == null) return path; cur = cur[p]; }
  return cur == null ? path : cur;
};
